module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-indexlist"
  }, [_c('p', {
    staticClass: "page-indexlist-desc"
  }, [_vm._v("此例请使用手机查看")]), _vm._v(" "), _c('div', {
    staticClass: "page-indexlist-wrapper"
  }, [_c('mt-index-list', _vm._l((_vm.alphabet), function(item) {
    return _c('mt-index-section', {
      attrs: {
        "index": item.initial
      }
    }, [_c('mt-cell-group', {
      attrs: {
        "grouppaddingleft": "16px"
      }
    }, _vm._l((item.cells), function(cell) {
      return _c('mt-cell', {
        attrs: {
          "title": cell,
          "cellheight": "44px"
        }
      })
    }))], 1)
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05844be8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/index-list.vue
// module id = 542
// module chunks = 0